import { getRelativeFontSize, mediumFont, theme } from "../../utils/styles";

const LeaveStyles = {
  attendanceWrapper: {
    padding: "25px",
  },
  indicWrapper: {
    display: "flex",
    gap: "25px",
  },
  indicBox: {
    display: "flex",
    gap: "5px",
  },
  presentBox: {
    background: "#18CB8A",
    width: "20px",
    height: "20px",
    borderRadius: "5px",
  },
  LeaveBoxPart: {
    display: "flex",
    gap: "30px",
  },
  LeaveBox: {
    background: "#E92B2B",
    width: "20px",
    height: "20px",
    borderRadius: "5px",
  },
  HolidayBox: {
    background: "#F4BE5E",
    width: "20px",
    height: "20px",
    borderRadius: "5px",
  },
  WeeklyOffBox: {
    background: "#8B91EF",
    width: "20px",
    height: "20px",
    borderRadius: "5px",
  },
  dataStyle: {
    ...mediumFont,
    fontSize: getRelativeFontSize(0),
  },

  filterButton: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    justifyContent: "center",
    height: "46px",
  },

  filterName: {
    ...mediumFont,
    fontSize: getRelativeFontSize(2),
    color: "#11142D",
    '& img' : {
      marginLeft  :"10px"
    }
  },

  verticalDotButton: {
    "& button": {
      "&:hover": {
        background: "none",
      },
    },
  },
  customButton: {
    margin: "14px auto 0",
    [theme.breakpoints.up("xl")]: {
      width  :"220px",
    },
  },
  innerPopOver: {
    padding: "5px",
    display: "flex",
    width: "100%",
    height: "100%",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "start",
    "& button": {
      width: "fit-content",
      "&:hover": {
        background: "none",
      },
    },
  },
  datePickerBox:{
    margin:"0",
    "& .MuiFormLabel-root":{
      fontSize:"14px",
      top:"-6px",
    },
    "& .MuiInputBase-input":{
      padding:"12px 10px",
      fontSize:"12px",
    },
  },
};

export default LeaveStyles;
